<template>
  <b-sidebar id="sidebar-gradeattendance" title="Calificar Asistencia" sidebar-class="bb-offcanvas-panel full"
             width="100%"
             bg-variant="white" right backdrop-variant="dark" backdrop no-header shadow
             @change="onLtiPanelVisibilityChange" @shown="getClassrooms">
    <template #default="{ hide }">
      <div class="bb-offcanvas-panel-wrap">
        <div class="panel-main-content-height" v-if="!pre_grade">
          <header class="page-header page-header-collapsed">
            <div class="page-title-wrapper">
              <h1 class="page-title">{{ $t("sessions.gradeattendance") }}</h1>
            </div>
            <button class="bb-close" v-on:click="hide">
              <span>{{ $t("buttons.close") }}</span><i class="isax isax-close-circle"/>
            </button>
          </header>
          <div id="body-content" class="body-content instances-container">
            <div class="page-controls">
              <div class="page-controls__control-row">
                <div class="page-controls__filter recordings-search">
                  <div class="dropdown-filter select-wrapper">
                    <i class="isax isax-filter border-0" />
                    <span class="dropdown-filter__select-label span-filter-by-text-grade-attendance">{{ $t("sessions.filterby") }}</span>
                    <b-dropdown id="dropdown-right" right v-model="selected" :text="selected" class="dropdown-group-grade" variant=" dropdown-filter__select button-select dropdown">
                      <b-dropdown-item @click="getClassrooms($event)" v-for="group in groups" :key="group.unirid" v-if="group.unirid != '' && group.unirid != null && group.unirid != undefined" :title="group.name">{{ group.name }}</b-dropdown-item>
                    </b-dropdown>
                  </div>
                </div>
              </div>
            </div>
            <div id="sessioncontainer" class="full-width-content--small" v-show="!loading">
              <div class="d-flex align-items-center mb-4">
                <div class="checkbox-wrap list checkbox-wrap-grade-all ml-1">
                  <input id="all-classroom-selector" checked type="checkbox" @change="toggleAllClassroom"/>
                  <label for="all-classroom-selector">{{ $t("sessions.gradeattendancemodal.checklistcontrol") }}</label>
                </div>
              </div>
              <ul class="item-list session-list" v-show="!loading">
                <li v-for="classroom in classrooms" v-bind:key="classroom.id" v-if="classrooms.length">
                  <div class="item-list__item session-list-item-content item-list__item--active">
                    <div class="item-list__item-details d-flex flex-column flex-md-row align-items-md-center">
                      <div class="checkbox-wrap list checkbox-wrap-grade-all checkbox-assistance-report-label" @click.stop>
                        <input :id="'list-classroom-check-' + classroom.id" name="list_classroom_check" type="checkbox" v-model="classroom.checked" @click.stop>
                        <label :for="'list-classroom-check-' + classroom.id" @click.stop></label>
                      </div>
                      <div class="name-container-report-assistance">
                        <span class="name">
                          {{ classroom.name }}
                        </span>
                        <span class="description" v-html="classroom.description"></span>
                      </div>
                      <span class="element-spam-report-assistance">
                        <span class="title">
                          <p>{{ $t("sessions.start") }}</p>
                        </span>
                        <span class="content">
                          <bdi>{{ classroom.start | moment("DD/MM/YYYY - HH:mm") }}</bdi>
                        </span>
                      </span>
                      <span class="element-spam-report-assistance">
                        <span class="title">
                          <p>{{ $t("sessions.end") }}</p>
                        </span>
                        <span class="content">
                          <bdi>{{ classroom.end | moment("DD/MM/YYYY - HH:mm") }}</bdi>
                        </span>
                      </span>
                      <span class="element-spam-report-assistance">
                        <span class="title">
                          <p>{{ $t("sessions.reusemodal.status") }}</p>
                        </span>
                        <div v-if="isOngoing(classroom)" class="content d-flex align-items-center session-state state-in-progress">
                          <bdi class="progress-status-sessions">{{ $t("sessions.inprogress") }}</bdi>
                        </div>
                        <div v-if="!isOngoing(classroom) && notYetStarted(classroom)" class="content d-flex align-items-center session-state state-not-started">
                          <bdi class="progress-status-sessions">{{ $t("sessions.notstarted") }}</bdi>
                        </div>
                        <div v-if="!isOngoing(classroom) && hasEnded(classroom)" class="content d-flex align-items-center session-state state-finished">
                          <bdi class="progress-status-sessions">{{ $t("sessions.finished") }}</bdi>
                        </div>
                      </span>
                    </div>
                  </div>
                </li>
                <div v-if="!classrooms.length" class="no-content no-results">
                  <span class="no-content-title">{{ $t("sessions.gradeattendancemodal.noresults") }}</span>
                </div>
              </ul>
            </div>
            <button class="page-controls__primary-action button primary short gradebutton" @click="showPreGrade" v-if="showButtonPreGrade">
              <span>{{ $t("sessions.gradeattendancemodal.gradebutton") }}</span>
            </button>
          </div>
        </div>
        <PreGrade v-if="pre_grade" :classrooms="classrooms" :gradable_activities="gradable_activities" :selected="selected" :selectedId="selectedId" @back="hidePreGrade" @hide="hide"/>
      </div>
    </template>
</b-sidebar>
</template>

<script>
import CloseIcon from 'vue-material-design-icons/Close.vue'
import jwtMixin from '../../../mixins/jwtMixin'
import utilitiesMixin from '../../../mixins/utilitiesMixin'
import ltiFrameMixin from '../../../mixins/ltiFrameMixin'
import SortDescendingIcon from 'vue-material-design-icons/SortDescending.vue'
import ArrowRightIcon from 'vue-material-design-icons/ArrowRight.vue'
import CheckIcon from 'vue-material-design-icons/Check.vue'
import ChevronDownIcon from 'vue-material-design-icons/ChevronDown.vue'
import ChevronUpIcon from 'vue-material-design-icons/ChevronUp.vue'
import ChevronRightIcon from 'vue-material-design-icons/ChevronRight.vue'
import PreGrade from './PreGrade'

export default {
  name: 'GradeAttendanceSidebar',
  components: {CloseIcon, SortDescendingIcon, ArrowRightIcon, CheckIcon, ChevronDownIcon, ChevronUpIcon, ChevronRightIcon, PreGrade},
  mixins: [jwtMixin, utilitiesMixin, ltiFrameMixin],
  props: ['groups'],
  mounted () {
    this.$moment.locale('es')
  },
  created () {
    this.$i18n.locale = this.jwtLanguage()
  },
  data () {
    return {
      loading: false,
      classrooms: [],
      pre_grade: false,
      selected: null,
      selectedId: null,
      gradable_activities: []
    }
  },
  computed: {
    showButtonPreGrade () {
      return this.classrooms.some(classroom => classroom.checked)
    }
  },
  watch: {
  },
  methods: {
    /**
     * Las vistas del panel de calificación (listado, previsualización y detalle) se
     * intercambian dentro del mismo b-sidebar, que solo emite `change` al abrirse y
     * cerrarse. Como la vista nueva se pinta al comienzo del panel, si el usuario
     * había bajado por la página del LMS se abriría fuera de pantalla, así que en
     * cada cambio de vista hay que pedir el scroll explícitamente.
     */
    showPreGrade () {
      this.pre_grade = true
      this.scrollLtiFrameToTop()
    },
    hidePreGrade () {
      this.pre_grade = false
      this.scrollLtiFrameToTop()
    },
    getClassrooms (event) {
      let vueComponent = this
      this.classrooms = []
      let filterParams = {}
      if (this.groups.filter(group => group.unirid !== '' && group.unirid != null && group.unirid !== undefined).length === 0) {
        vueComponent.$noty.error(vueComponent.$i18n.t('sessions.gradeattendancemodal.attendancemodal.existssid'), {
          timeout: 3000,
          progressBar: true
        })
        let closeViewButton = window.document.querySelector('#close-view-attendance')
        closeViewButton.click()
      }
      if (event != null && event !== undefined) {
        let groupName = event.target.text

        for (let i = 0; i < this.groups.length; i++) {
          if (this.groups[i].name === groupName) {
            vueComponent.selected = vueComponent.groups[i].name
            vueComponent.selectedId = vueComponent.groups[i].unirid
            filterParams = {
              groups: vueComponent.groups[i].unirid
            }
            break
          }
        }
      } else if (vueComponent.selected != null) {
        // FNO: En caso de estar ya informado el grupo y no lanzarse el evento de cambio de grupo, no se hara nada. Evita el reinicio de grupo cuando se cierra y vuelve a abrir calificaciones.
        let groupName = vueComponent.selected

        for (let i = 0; i < this.groups.length; i++) {
          if (this.groups[i].name === groupName) {
            vueComponent.selected = vueComponent.groups[i].name
            vueComponent.selectedId = vueComponent.groups[i].unirid
            filterParams = {
              groups: vueComponent.groups[i].unirid
            }
            break
          }
        }
      } else {
        this.selected = this.groups[0].name
        this.selectedId = this.groups[0].unirid
        filterParams = {
          groups: this.groups[0].unirid
        }
      }
      filterParams.targetStatus = true

      if (filterParams.groups !== undefined && filterParams.groups !== null) {
        // Se buscan las clases pertenecientes al grupo seleccionado o el primero de los grupos a los que pertenece el usuario
        window.axios.get('classrooms/', {params: filterParams}).then((response) => {
          vueComponent.classrooms = response.data.results.map(classroom => ({
            ...classroom,
            checked: true
          }))
          vueComponent.getGradableActivities()
        })
      }
    },
    getGradableActivities () {
      let vueComponent = this
      const licenceId = this.jwtConsumerId()
      const site = this.jwtContextSite()
      this.gradable_activities = []
      window.axios.get('licences/' + licenceId + '/site/' + site + '/gradableactivities').then(response => {
        vueComponent.gradable_activities = response.data
        vueComponent.loading = false
      })
    },
    toggleAllClassroom (event) {
      let listClassroomCheck = document.getElementsByName('list_classroom_check')
      listClassroomCheck.forEach(check => {
        if (event.target.checked !== check.checked) {
          check.click()
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Lti/SessionsModals/GradeAttendanceSidebar.vue